<template>
  <div class="app-container">
    <div class="top_item">
      <div class="add_cate"
        @click="addCate">新建分类</div>
      <div class="search"
        @click="searchCate">搜索</div>
      <el-input placeholder="输入分类名称搜索"
        size="mini"
        v-model="classform.name"
        style="float:right;width:160px;margin-right:4px;margin-top:-18px;"></el-input>
      <span style="float:right;margin-top:-18px;margin-right:4px;color:#666">关键字搜索</span>
    </div>

    <el-table :data="tableData"
      border
      max-height="600"
      size="mini"
      style="width: 100%"
      :cell-style="tc"
      :header-cell-style="tc"
      @selection-change="handleSelectionChange"
      v-loading="listLoading">
      <el-table-column type="selection"
        width="55"> </el-table-column>
      <el-table-column label="分类ID"
        prop="id"></el-table-column>
      <el-table-column label="分类图片">
        <template slot-scope="scope">
          <img style="width:36px;height:36px;"
            :src="scope.row.icon" />
        </template>
      </el-table-column>
      <el-table-column label="分类名称"
        prop="name"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <div class="account_status_start"
            v-if="scope.row.status == 1">●</div>
          <div class="account_status_end"
            v-else>●</div>
          <span v-if="scope.row.status == 1">启用中</span>
          <span v-else>已禁用</span>
        </template>
      </el-table-column>
      <el-table-column label="子分类">
        <template slot-scope="scope">
          <div class="children_cate"
            @click="watchChildrenCate(scope.row.id)">
            查看子分类 >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="展示排序">
        <template slot-scope="scope">
          <div class="children_cate">
            {{ scope.row.sort }}
            <i class="el-icon-edit"
              @click="updateCateOrder(scope.row.id, scope.row.sort)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作"
        fixed="right"
        width="340">
        <template slot-scope="scope">
          <el-button size="mini"
            @click="addchildrenCate(scope.row.name, scope.row.id)">添加子分类</el-button>
          <el-button size="mini"
            type="success"
            v-if="scope.row.status == 1"
            @click="disableCate(scope.row.id, 2)">禁用</el-button>
          <el-button size="mini"
            type="info"
            v-else
            @click="disableCate(scope.row.id, 1)">启用</el-button>
          <el-button size="mini"
            type="warning"
            @click="categoriesDetailData(scope.row.id)">编辑</el-button>
          <el-button size="mini"
            type="danger"
            @click="deleteClass(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row v-show="total > 0">
      <el-col :span="4"
        style="padding:12px 0;">
        <el-button :disabled="selectedList.length === 0"
          type="success"
          size="small"
          @click="batchClassToDelete">批量删除</el-button>
      </el-col>
      <el-col :span="20">
        <div class="pagination">
          <el-pagination background
            @size-change="handleSizeChange"
            @current-change="pageChange"
            :current-page="classform.page"
            :page-sizes="[20, 50, 100]"
            :page-size="classform.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!--查看子分类-->
    <gydialog title="查看子分类"
      :visible.sync="showChildrenCate"
      width="740px;">
      <el-table :data="childrenData"
        max-height="600"
        size="mini"
        style="width: 100%"
        :cell-style="tc"
        :header-cell-style="tc">
        <el-table-column label="分类ID"
          prop="id"></el-table-column>
        <el-table-column label="分类图片">
          <template slot-scope="scope">
            <img style="width:36px;height:36px;"
              :src="scope.row.icon" />
          </template>
        </el-table-column>
        <el-table-column label="分类名称"
          prop="name"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div class="account_status_start"
              v-if="scope.row.status == 1">
              ●
            </div>
            <div class="account_status_end"
              v-else>●</div>
            <span v-if="scope.row.status == 1">启用中</span>
            <span v-else>已禁用</span>
          </template>
        </el-table-column>
        <el-table-column label="排序">
          <template slot-scope="scope">
            <div class="children_cate">
              {{ scope.row.sort }}
              <i class="el-icon-edit"
                @click="updateCateOrder(scope.row.id, scope.row.sort)"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作"
          fixed="right"
          width="240">
          <template slot-scope="scope">
            <el-button size="mini"
              type="success"
              v-if="scope.row.status == 1"
              @click="disableCate(scope.row.id, 2)">禁用</el-button>
            <el-button size="mini"
              type="info"
              v-else
              @click="disableCate(scope.row.id, 1)">启用</el-button>
            <el-button size="mini"
              type="warning"
              @click="categoriesDetailData(scope.row.id)">编辑</el-button>
            <el-button size="mini"
              type="danger"
              @click="deleteClass(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
          @current-change="childrenpageChange"
          :current-page="childrenform.page"
          :page-size="childrenform.page_size"
          layout="total, prev, pager, next, jumper"
          :total="childrentotal">
        </el-pagination>
      </div>
    </gydialog>

    <!--新增分类-->
    <gydialog :title="title"
      width="640px"
      :visible.sync="showAddCate"
      isComponent="true"
      @handleCancel="cancelAddCate">
      <el-form :model="cateForm"
        :rules="rules"
        style="padding:20px 30px;"
        ref="ruleForm"
        label-width="130px">
        <el-form-item v-if="title == '添加子分类'"
          label="关联父级分类名称:">
          <div style="float:left;margin-left:44px;">{{ parent_name }}</div>
        </el-form-item>
        <el-form-item label="商品分类名称:"
          prop="name">
          <el-input size="mini"
            v-model="cateForm.name"
            style="width:240px;margin-left:-128px;"
            placeholder="请输入商品分类名称"></el-input>
        </el-form-item>

        <el-form-item label="商品分类排序:"
          prop="order">
          <el-input size="mini"
            style="width:100px;"
            placeholder="0~99"
            v-model="cateForm.sort"></el-input><span style="margin-left:12px;color:#999;font-size:12px;">数值越大越靠前,数值相同两个品类,系统随机展示</span>
        </el-form-item>

        <el-form-item label="分类icon:"
          prop="icon">
          <uploadImg flieName="icon"
            class="text_left"
            :oldImgs="[cateForm.icon]"
            :n="1"
            @getFile="getFile"></uploadImg>
          <span style="color:#999;font-size:12px;margin-left:-156px;">支持png、jpg格式图片，大小不超过1M</span>
        </el-form-item>

        <!-- <el-form-item label="关联分类:"
          prop="supplier_categories">
          <div>
            <el-tag v-for="(tag, index) in selectedTypes"
              :style="
							index == 0 && selectedTypes.length <= 1
								? 'margin-left:-160px;'
								: ''
						"
              :key="tag.id"
              closable
              @close="handleClose(index)"
              type="success">
              {{ tag.name }}
            </el-tag>
          </div> -->

          <!-- <div v-else>
            <el-tag v-for="(tag, index) in selectedTypes"
              :style="
							index == 0 && selectedTypes.length <= 1
								? 'margin-left:-160px;'
								: ''
						"
              :key="tag.id"
              type="success">
              {{ tag.name }}
            </el-tag>
          </div> -->

          <!-- <div>
            <el-button style="margin-left:-254px;"
              type="warning"
              size="small"
              icon="el-icon-plus"
              @click="showTypeList">关联1688分类</el-button>
          </div> -->
        <!-- </el-form-item> -->
      </el-form>

      <div style="text-align:center;margin:">
        <el-button size="mini"
          @click="cancelAddCate">取消</el-button>
        <el-button size="mini"
          type="primary"
          @click="certainAddCate">确定</el-button>
      </div>
    </gydialog>

    <gydialog title="关联1688分类"
      :visible.sync="dialogVisible"
      width="600px">
      <div>
        <ali-types :visible="dialogVisible"
          :type="classalitype"
          :pid="pid"
          :selectedTypes="selectedTypes"
          @close="dialogVisible = false"
          @getSelected="getSelected"></ali-types>
      </div>
    </gydialog>

    <!--修改排序-->
    <gydialog title="修改排序"
      :visible.sync="showChangeOrder"
      width="540px;">
      <div style="padding:20px 30px;">
        <span style="margin-right:12px;">分类排序:</span>
        <el-input size="mini"
          v-model="cateorder"
          placeholder="请输入商品分类排序"
          style="width:270px;"></el-input>

        <div style="text-align:center;margin:10px">
          <el-button size="mini"
            @click="cancelCateSort">取消</el-button>
          <el-button size="mini"
            type="danger"
            @click="certainCateSort">确定</el-button>
        </div>
      </div>
    </gydialog>
  </div>
</template>
<script>
import uploadImg from '@/components/uploadImg'
import aliTypes from './aliTypes'
import {
  productCategoryGet,
  insertProductCate,
  updateProductCateSort,
  updateCateStatus,
  deleteProductCategories,
  categoriesDetail,
  updateProductCate
} from '@/api/goods'
export default {
  components: {
    uploadImg,
    aliTypes
  },
  data () {
    return {
      title: '新增商品分类',
      classform: {
        name: '',
        page: 1,
        page_size: 20,
        parent_id: '',
        status: ''
      },
      tableData: [],
      total: 0,
      listLoading: false,
      selectedList: [],
      showAddCate: false,
      selectedTypes: [],
      dialogVisible: false,
      cateForm: {
        name: '', //分类名称
        sort: '', //排序
        icon: '', //图片
        //	top_id: '', //没有不传
        //	parent_id: '', //没有不传
        supplier_categories: '' //1688分类
      },
      rules: {
        name: [
          { required: true, message: '请输入商品分类名称', trigger: 'blur' }
        ],
        order: [
          { required: true, message: '请输入商品分类排序', trigger: 'blur' }
        ],

        // icon: [
        // 	{ required: true, message: '请上传商品分类图片', trigger: 'blur' }
        // ],
        // supplier_categories: [
        //   { required: true, message: '请关联1688分类', trigger: 'blur' }
        // ]
      },

      showChangeOrder: false,
      cateorder: '',
      cateId: '',
      editId: '',
      parent_name: '',
      showChildrenCate: false,
      childrenform: {
        name: '',
        page: 1,
        page_size: 20,
        parent_id: '',
        status: ''
      },
      childrentotal: 0,
      childrenData: [],


      classalitype: 1,
      pid: '',
    }
  },
  activated () {
    this.productCategoryGetData()
  },
  methods: {
    //新增分类
    addCate () {
      this.title = '新增商品分类'
      this.classalitype = 1
      this.pid = ''
      this.showAddCate = true
    },
    //搜索
    searchCate () {
      this.pageChange(1)
    },
    handleClose (index) {
      this.selectedTypes.splice(index, 1)
    },
    showTypeList () {
      this.dialogVisible = true
    },
    getSelected (arr) {
      this.dialogVisible = false
      this.selectedTypes = arr
    },
    //确定新增分类
    certainAddCate () {
      if (!this.cateForm.name) {
        this.$message.error('商品分类名称不能为空')
        return
      }
      if (!this.cateForm.sort) {
        this.$message.error('商品分类排序不能为空')
        return
      }
      if (Number(this.cateForm.sort) <= 0 || Number(this.cateForm.sort) > 99) {
        this.$message.error('商品分类排序范围为1~99')
        return
      }
      // if (!this.cateForm.icon) {
      // 	this.$message.error('商品分类图片不能为空')
      // 	return
      // }
      // if (this.selectedTypes.length == 0) {
      //   this.$message.error('商品关联1688分类不能为空')
      //   return
      // }
      this.cateForm.supplier_categories = JSON.stringify(this.selectedTypes)

      if (this.title == '编辑商品分类') {
        this.updateProductCateData()
      } else {
        this.insertProductCateData()
      }
    },
    //取消新增分类
    cancelAddCate () {
      console.log('@handleCancel="cancelAddCate"')
      this.showAddCate = false
      this.pid = ''
      this.selectedTypes = []
      this.cateForm = {
        name: '',
        sort: '',
        icon: '',
        top_id: '',
        parent_id: '',
        supplier_categories: ''
      }
    },
    //添加子分类
    async addchildrenCate (name, id) {
      console.log('id=' + id)
      this.parent_name = name
      this.cateForm.parent_id = id
      this.title = '添加子分类'
      let res = await categoriesDetail(id)
      this.classalitype = '2'
      var pidarr = []

      if (res.supplier_categories) {
        res.supplier_categories.map(item => {
          // this.selectedTypes.push({
          //   id: item.id,
          //   name: item.supplier_cate_name
          // })
          pidarr.push(item.supplier_cate_id)
        })
      }
      this.pid = JSON.stringify(pidarr)
      this.showAddCate = true
    },
    //新增商品分类
    async insertProductCateData () {
      var form = {}
      if (this.cateForm.parent_id) {
        form = {
          name: this.cateForm.name,
          sort: this.cateForm.sort,
          icon: this.cateForm.icon,
          supplier_categories: this.cateForm.supplier_categories,
          parent_id: this.cateForm.parent_id
        }
      } else {
        form = {
          name: this.cateForm.name,
          sort: this.cateForm.sort,
          icon: this.cateForm.icon,
          supplier_categories: this.cateForm.supplier_categories
        }
      }
      let res = await insertProductCate(form)

      console.log(res)
      this.$message.success('新增分类成功')
      this.cancelAddCate()
      this.productCategoryGetData()
    },
    //确定修改排序
    updateCateOrder (id, sort) {
      this.cateorder = sort
      this.cateId = id
      this.showChangeOrder = true
    },
    certainCateSort () {
      if (!this.cateorder) {
        this.$message.error('分类排序不能为空')
        return
      }
      this.updateProductCateSortData()
    },
    //取消修改排序
    cancelCateSort () {
      this.cateorder = ''
      this.showChangeOrder = false
    },
    //修改排序
    async updateProductCateSortData () {
      let res = await updateProductCateSort(this.cateId, {
        id: this.cateId,
        sort: this.cateorder
      })
      console.log(res)
      this.$message.success('成功修改排序')
      this.productCategoryGetData()
      this.cancelCateSort()
    },
    //删除
    batchClassToDelete () {
      this.$confirm('确定批量删除账户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const selectedList = this.selectedList
        if (selectedList.length > 0) {
          const arr = []
          selectedList.forEach(item => {
            arr.push(item.id)
          })
          this.deleteProductCategoriesData(JSON.stringify(arr))
        }
      })
    },
    //删除用户
    deleteClass (id) {
      this.$confirm('确定删除分类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteProductCategoriesData(JSON.stringify([id]))
        })
        .catch(() => {
          console.log('cancel')
        })
    },
    //删除分类
    async deleteProductCategoriesData (ids) {
      let res = await deleteProductCategories({ ids: ids })
      console.log(res)
      this.$message.success('删除分类成功')
      this.productCategoryGetData()
    },

    //编辑
    async updateProductCateData () {
      var form = {
        name: this.cateForm.name,
        sort: this.cateForm.sort,
        icon: this.cateForm.icon,
        supplier_categories: this.cateForm.supplier_categories
      }
      let res = await updateProductCate(this.editId, form)
      console.log(res)
      this.$message.success('编辑成功')
      this.cancelAddCate()
      this.productCategoryGetData()
    },
    //获取详情
    async categoriesDetailData (id) {
      this.editId = id

      let res = await categoriesDetail(id)

      this.cateForm.name = res.name
      this.cateForm.sort = res.sort
      this.cateForm.icon = res.icon
      // var pidarr = []
      if (res.supplier_categories) {
        res.supplier_categories.map(item => {
          this.selectedTypes.push({
            id: item.id,
            name: item.supplier_cate_name
          })

          // if (this.showChildrenCate) {
          //   pidarr.push(item.id)
          // }
        })
      }

      // if (this.showChildrenCate) {
      //   this.classalitype = '2'
      //   this.pid = JSON.stringify(pidarr)
      // } else {
      //   this.classalitype = '1'
      //   this.pid = ''
      // }
      this.title = '编辑商品分类'
      this.showAddCate = true
    },
    handleSizeChange (val) {
      this.classform.size = val
      this.pageChange(1)
    },
    pageChange (page) {
      this.classform.page = page
      this.productCategoryGetData()
    },
    childrenpageChange (page) {
      this.childrenform.page = page
      this.productCategoryGetData()
    },
    //获取分类列表数据
    async productCategoryGetData () {
      var form
      if (!this.showChildrenCate) {
        form = this.classform
      } else {
        form = this.childrenform
      }
      let res = await productCategoryGet(form)
      if (!this.showChildrenCate) {
        this.total = res.total
        this.tableData = res.data
      } else {
        this.childrenData = res.data
        this.childrentotal = res.total
      }
    },
    //查看子分类
    watchChildrenCate (parent_id) {
      this.childrenform.parent_id = parent_id
      this.showChildrenCate = true
      this.productCategoryGetData()
    },
    //启用、禁用排序
    disableCate (id, status) {
      this.updateCateStatusData(id, status)
    },
    async updateCateStatusData (id, status) {
      let res = await updateCateStatus(id, { status: status })
      console.log(res)
      this.$message.success('操作成功')
      this.productCategoryGetData()
    },
    getFile (file) {
      this.cateForm[file.name] = file.files.length > 0 ? file.files[0].url : ''
    },
    tc () {
      return 'text-align:center;'
    },
    handleSelectionChange (arr) {
      this.selectedList = arr
    }
  }
}
</script>
<style lang="scss" scoped>
// @import 'src/styles/mixin.scss';
.app-container {
	padding: 20px;
	background-color: #fff;
}
.top_item {
	background-color: #fff;
	border-radius: 4px;
	height: 64px;
	line-height: 64px;
}
.children_cate {
	border: 1px dashed rgb(222, 222, 222);
	padding: 4px 8px;
	cursor: pointer;
}
.add_cate {
	float: left;
	width: 100px;
	height: 30px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 30px;
	border-radius: 4px;
	cursor: pointer;
}
.el-icon-edit {
	font-size: 16px;
	float: right;
	color: #3498d8;
}
.search {
	float: right;
	width: 64px;
	height: 28px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 28px;
	border-radius: 4px;
	cursor: pointer;
}
.account_status_start {
	color: #67c23a;
	float: left;
	width: 4px;
	padding-left: 16px;
	text-align: center;
	border-radius: 50%;
}
.account_status_end {
	color: #f4222d;
	float: left;
	width: 4px;
	padding-left: 16px;
	text-align: center;
	border-radius: 50%;
}
.text_left {
	text-align: left;
	margin-left: 44px;
}
</style>
